import { Loader } from '@nordlayer/rivendell-ui';
import loadable from '@nordvpn/teams.core/lib/tools/loadable';
import { RouteGenerator } from 'routing/RouteGenerator';
import { PermissionsEnum } from 'types/permissions/enums';
import { MSP_PARTNERS_CREATE_PATH, MSP_PARTNER_DETAILS_PATH, MSP_PARTNER_EDIT_PATH, PARTNERS_CREATE_PATH, PARTNERS_EDIT_PATH, PARTNERS_PATH } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
var Partners = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/Partners');
});
var CreatePartner = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/CreatePartnerPage');
});
var EditPartner = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/EditPartnerPage');
});
var MspPartners = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/MspPartners');
});
var CreateMspPartner = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/CreateMspPartner');
});
var MspPartnerDetails = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/MspPartnerDetails');
});
var EditMspPartner = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/EditMspPartner');
});
export var PartnersRouting = function PartnersRouting(_ref) {
    var areFeaturesLoaded = _ref.areFeaturesLoaded, isMspPartnersEnabled = _ref.isMspPartnersEnabled;
    var getListPage = function getListPage() {
        if (!areFeaturesLoaded) {
            return /*#__PURE__*/ _jsx(Loader, {
                centered: true
            });
        }
        return isMspPartnersEnabled ? /*#__PURE__*/ _jsx(MspPartners, {}) : /*#__PURE__*/ _jsx(Partners, {});
    };
    return RouteGenerator({
        list: {
            path: PARTNERS_PATH,
            component: function component() {
                return getListPage();
            },
            exact: true,
            permission: PermissionsEnum.ViewPartner
        },
        create: {
            path: PARTNERS_CREATE_PATH,
            component: CreatePartner,
            exact: true,
            permission: PermissionsEnum.CreatePartner
        },
        createMsp: {
            path: MSP_PARTNERS_CREATE_PATH,
            component: CreateMspPartner,
            exact: true,
            permission: PermissionsEnum.CreatePartner
        },
        edit: {
            path: PARTNERS_EDIT_PATH,
            component: EditPartner,
            exact: true,
            permission: PermissionsEnum.ModifyPartner
        },
        editMsp: {
            path: MSP_PARTNER_EDIT_PATH,
            component: EditMspPartner,
            exact: true,
            permission: PermissionsEnum.ModifyPartner
        },
        detailsMsp: {
            path: MSP_PARTNER_DETAILS_PATH,
            component: MspPartnerDetails,
            exact: true,
            permission: PermissionsEnum.ViewPartner
        }
    });
};
